import CloseButton from "@components/common/CloseButton";
import { QUOTE_REQUESTS_MQ } from "@components/home/routes";
import { CONTACT_FORM_INITIAL_VALUE } from "@components/utils/constants";
import getReferralType from "@components/utils/getReferralType";
import useEnhancedConversions from "@hooks/useEnhancedConversions";
import Form from "@libs/forms/Form";
import { ERROR_TEXTS, MAX_LENGTH } from "@libs/forms/utils/constants";
import { getCookie } from "cookies-next";
import { useRouter } from "next/router";
import { useCallback, useMemo, useState } from "react";
import * as Yup from "yup";
import ContactFormFields from "./ContactFormFields";
interface IdefaultValues {
  fullName: string;
  email: string;
  phoneNumber: string;
  description: string;
}

const ContactForm = (): JSX.Element => {
  const router = useRouter();
  const [showToastMessage, setShowToastMessage] = useState(false);
  const [showButtonSpinner, setShowButtonSpinner] = useState(false);

  const [serverError, setServerError] = useState(false);

  const handleClose = useCallback(() => {
    setShowToastMessage(false);
  }, []);

  const { setEnhancedConversions } = useEnhancedConversions();

  const setErrorServerAction = () => {
    setServerError(true);
    window.scrollTo(0, 0);
    setShowButtonSpinner(false);
    setShowToastMessage(true);
    setTimeout(() => {
      setShowToastMessage(false);
    }, 3000);
  };

  const onSubmit = async (data: any): Promise<void> => {
    setShowButtonSpinner(true);

    try {
      await fetch("/api/contact-us/verifyToken", {
        method: "POST",
        body: JSON.stringify({ token: data.turnstile_token }),
      });

      delete data.turnstile_token;
      await requestAQuote(data);
    } catch (err) {
      console.log(err);
      setErrorServerAction();
    }
  };

  const requestAQuote = async (data: any) => {
    setEnhancedConversions({
      user_data: {
        full_name: data.fullName,
        user_email: data.email,
        phone_number: data.phoneNumber,
      },
    });

    data.Activities = "";
    data.Locations = "";
    data.Lodging = "";
    data.UsrSourceValue = getCookie("roasurl");
    data.UsrReferralType = getReferralType();
    data.PageURL = window.location.href;

    try {
      const res = await fetch(QUOTE_REQUESTS_MQ, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (res.status !== 200) {
        setErrorServerAction();
        return;
      }

      router.push("/thank-you");
    } catch (err) {
      console.log(err);
      setErrorServerAction();
    }
  };

  const validationSchema = Yup.object().shape({
    fullName: Yup.string()
      .required(ERROR_TEXTS.requiredFullName)
      .max(MAX_LENGTH.name, ERROR_TEXTS.maxFullName),
    email: Yup.string()
      .required(ERROR_TEXTS.requiredEmail)
      .email(ERROR_TEXTS.validEmail),
  });

  const defaultValues: IdefaultValues = useMemo(() => {
    return CONTACT_FORM_INITIAL_VALUE;
  }, []);

  return (
    <>
      <Form
        validationSchema={validationSchema}
        defaultValues={defaultValues}
        submitHandler={onSubmit}
      >
        <ContactFormFields showButtonSpinner={showButtonSpinner} />
      </Form>
      {showToastMessage && (
        <div
          className={`absolute top-[100px] mx-auto mb-4 flex h-11 w-[90%] justify-between rounded-3xl desktop:top-[70px] desktop:ml-10 desktop:w-[34rem] ${
            serverError
              ? "border-2 border-negative-100 bg-orange-10"
              : "bg-blue-10"
          }`}
        >
          <p className="my-auto ml-6 text-p13 font-medium text-black ">
            {serverError
              ? "An error occurred while processing your request."
              : "Your request was successfully submitted."}
          </p>
          <div className="my-auto mr-2">
            <CloseButton onClick={handleClose} serverError={serverError} />
          </div>
        </div>
      )}
    </>
  );
};

export default ContactForm;
